/* Unterer Bereich der Produktseite (snippets/dpv2-details.liquid).
   Uebernommen aus der alten Sektion dayvee-product-page und ihren Zusatzschichten:
   - Inhaltsstoffe & Naehrwerte je Sorte bzw. je gewaehltem Bundle-Produkt (Tabellen aus custom.datentabellen)
   - Bundles: Beschreibung und Herstellerangaben der enthaltenen Produkte
   - Wichtige Hinweise fuer Nahrungsergaenzungsmittel (Pflichtsaetze nur einmal)
   - Hersteller und FAQ zum Aufklappen
   Liest nur. Auswahl, Preise und Warenkorb bleiben bei der Kaufkachel (dayvee-pdp-v2). */
(function(){
  var dt = document.querySelector('[data-dpv2-dt]');
  if (!dt) return;
  var root = document.querySelector('[data-dpv2]');

  function readJson(sel, fb){ var n = dt.querySelector(sel); if (!n) return fb; try { return JSON.parse(n.textContent); } catch(e){ return fb; } }
  var content = readJson('[data-dpv2-dt-content]', null);
  var variants = readJson('[data-dayvee-product-json]', []);
  var isSupp = dt.getAttribute('data-dpv2-dt-supp') === 'true';

  var ingr = dt.querySelector('[data-dayvee-ingredients-dynamic]');
  var bDesc = dt.querySelector('[data-dayvee-bundle-description]');
  var bMaker = dt.querySelector('[data-dayvee-bundle-manufacturers]');
  var nem = dt.querySelector('[data-dayvee-nem-notices]');
  var descPanel = dt.querySelector('[data-dayvee-detail-panel="beschreibung"]');

  /* Aufklappen: Hersteller, FAQ */
  dt.querySelectorAll('[data-dayvee-accordion-trigger]').forEach(function(t){
    t.addEventListener('click', function(){
      var item = t.closest('[data-dayvee-detail-item]');
      var open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open);
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Hilfsfunktionen ---------- */
  function meaningful(html){
    if (!html || typeof html !== 'string') return false;
    var d = document.createElement('div'); d.innerHTML = html;
    return !!(d.textContent.trim() || d.querySelector('img, table, ul, ol, iframe, video'));
  }
  function rich(html, cls){ var w = document.createElement('div'); w.className = cls || 'dayvee-product__detail-richtext rte'; w.innerHTML = html; return w; }
  function heading(text){ var h = document.createElement('h3'); h.className = 'dayvee-product__detail-heading'; h.textContent = text; return h; }
  function rowsOf(raw){
    if (!raw || typeof raw !== 'string') return [];
    return raw.split(/\r?\n/).map(function(l){ return l.trim(); }).filter(Boolean).map(function(l){ return l.split('|').map(function(c){ return c.trim(); }); });
  }
  function parseTables(raw){
    if (!raw || typeof raw !== 'string') return [];
    var lines = raw.replace(/\r\n?/g, '\n').split('\n'), tables = [], cur = null;
    function ensure(){ if (!cur) cur = { title: '', lines: [], note: '' }; return cur; }
    function flush(){
      if (!cur) return;
      var data = cur.lines.map(function(l){ return l.trim(); }).filter(Boolean).join('\n');
      if (data) tables.push({ title: cur.title, data: data, note: cur.note });
      cur = null;
    }
    lines.forEach(function(raw){
      var line = raw.trim(); if (!line) return;
      var h = line.match(/^###\s+(.+)$/);
      if (h){ flush(); cur = { title: h[1].trim(), lines: [], note: '' }; return; }
      var n = line.match(/^Hinweis\s*:\s*(.*)$/i);
      if (n){ var t = ensure(), x = n[1].trim(); if (x) t.note = t.note ? t.note + ' ' + x : x; return; }
      if (line.indexOf('|') !== -1) ensure().lines.push(line);
    });
    flush();
    return tables;
  }
  function tableEl(td){
    var rows = rowsOf(td.data); if (!rows.length) return null;
    var cols = rows.reduce(function(m, r){ return Math.max(m, r.length); }, 0); if (!cols) return null;
    var w = document.createElement('div'); w.className = 'dayvee-product__data-table';
    if (td.title){ var t = document.createElement('h4'); t.className = 'dayvee-product__data-table-title'; t.textContent = td.title; w.appendChild(t); }
    var sc = document.createElement('div'); sc.className = 'dayvee-product__table-scroll'; sc.setAttribute('tabindex', '0'); sc.setAttribute('role', 'region');
    sc.setAttribute('aria-label', td.title ? 'Tabelle: ' + td.title : 'Datentabelle');
    var table = document.createElement('table'), thead = document.createElement('thead'), tbody = document.createElement('tbody'), hr = document.createElement('tr');
    for (var c = 0; c < cols; c++){ var th = document.createElement('th'); th.setAttribute('scope', 'col'); th.textContent = rows[0][c] || ''; hr.appendChild(th); }
    thead.appendChild(hr); table.appendChild(thead);
    rows.slice(1).forEach(function(r){ var tr = document.createElement('tr'); for (var c = 0; c < cols; c++){ var tdc = document.createElement('td'); tdc.textContent = r[c] || ''; tr.appendChild(tdc); } tbody.appendChild(tr); });
    if (rows.length > 1) table.appendChild(tbody);
    sc.appendChild(table); w.appendChild(sc);
    if (td.note){ var nt = document.createElement('div'); nt.className = 'dayvee-product__data-table-note rte'; var p = document.createElement('p'); p.textContent = td.note; nt.appendChild(p); w.appendChild(nt); }
    return w;
  }
  function tablesBlock(raw){
    var list = parseTables(raw); if (!list.length) return null;
    var box = document.createElement('div'); box.className = 'dayvee-product__detail-block dayvee-product__data-tables';
    var n = 0; list.forEach(function(t){ var el = tableEl(t); if (el){ box.appendChild(el); n++; } });
    return n ? box : null;
  }
  /* Naehrwertangaben ohne Tabellenstriche als Text zeigen (vorher dayvee-site-consistency-core) */
  function plainBlock(raw){
    raw = String(raw || '').trim();
    if (!raw || raw.indexOf('|') !== -1) return null;
    var w = document.createElement('div'); w.className = 'dayvee-product__detail-block dayvee-product__legacy-content rte dayvee-product__data-fallback';
    raw.replace(/\r\n?/g, '\n').split('\n').map(function(l){ return l.trim(); }).filter(Boolean).forEach(function(l){
      var h = l.match(/^###\s+(.+)$/);
      if (h){ var hn = document.createElement('h3'); hn.className = 'dayvee-product__detail-heading'; hn.textContent = h[1].trim(); w.appendChild(hn); return; }
      var p = document.createElement('p');
      if (/:$/.test(l)){ var s = document.createElement('strong'); s.textContent = l; p.appendChild(s); } else p.textContent = l;
      w.appendChild(p);
    });
    return w.childElementCount ? w : null;
  }
  function compactDesc(html){
    if (!meaningful(html || '')) return '';
    var s = document.createElement('div'); s.innerHTML = html;
    var ps = Array.prototype.slice.call(s.querySelectorAll('p'), 0, 2);
    if (ps.length){ var w = document.createElement('div'); ps.forEach(function(p){ w.appendChild(p.cloneNode(true)); }); return w.innerHTML; }
    return s.innerHTML;
  }
  function childTitle(c){
    var title = c.product_title || 'Bundle-Produkt', v = c.variant_title || '', parts = v.split(' – ');
    if (parts.length > 1 && title.indexOf(parts[0]) !== -1) v = parts.slice(1).join(' – ');
    return title + (v && v !== 'Default Title' && title.indexOf(v) === -1 ? ' – ' + v : '');
  }

  /* ---------- Auswahl lesen ---------- */
  function currentVariant(){
    var el = root && root.querySelector('[data-dpv2-id]');
    var id = el ? String(el.value || '') : '';
    for (var i = 0; i < variants.length; i++){ if (String(variants[i].id) === id) return variants[i]; }
    return variants.length === 1 ? variants[0] : null;
  }
  function isInfinite(children){ return children.some(function(c){ return c.bundle_type === 'Infinite options'; }); }
  /* Bundle mit freier Auswahl: nur die in der Kaufkachel gewaehlten Produkte (Felder der Bundle-App) */
  function selectedChildren(children){
    if (!Array.isArray(children)) return [];
    if (!isInfinite(children)) return children;
    var widget = root && root.querySelector('#simple-bundles-io-options');
    if (!widget) return [];
    var choices = {};
    widget.querySelectorAll('select[name^="properties["]').forEach(function(s){ var m = /^properties\[(.+)\]$/.exec(s.name); if (m) choices[m[1]] = s.value; });
    var seen = {};
    return children.filter(function(c){
      var rules = c.variant_options;
      if (!Array.isArray(rules) || !rules.length) return false;
      if (!rules.every(function(r){ return Object.prototype.hasOwnProperty.call(choices, r.name) && choices[r.name] === r.value; })) return false;
      var k = String(c.variant_id); if (seen[k]) return false; seen[k] = true; return true;
    });
  }

  /* ---------- Inhaltsstoffe & Naehrwerte ---------- */
  function renderChildContents(children){
    children = selectedChildren(children);
    var box = document.createElement('div'); box.className = 'dayvee-product__bundle-child-details';
    var n = 0;
    children.forEach(function(c){
      if (!c || typeof c !== 'object') return;
      var sec = document.createElement('section'); sec.className = 'dayvee-product__bundle-child';
      var t = document.createElement('h3'); t.className = 'dayvee-product__bundle-child-title'; t.textContent = childTitle(c);
      var q = Number(c.quantity || 1);
      if (q > 1){ var qs = document.createElement('span'); qs.className = 'dayvee-product__bundle-child-quantity'; qs.textContent = ' (' + q + '× enthalten)'; t.appendChild(qs); }
      sec.appendChild(t);
      var has = false;
      if (c.has_ingredients_data && meaningful(c.ingredients_html || '')){
        var ib = document.createElement('div'); ib.className = 'dayvee-product__detail-block';
        ib.appendChild(heading('Zutaten'));
        ib.appendChild(rich(c.ingredients_html, 'dayvee-product__detail-richtext dayvee-product__ingredients-richtext rte'));
        sec.appendChild(ib); has = true;
      }
      if (c.has_data_tables){
        var tb = tablesBlock(c.data_tables_raw || '');
        if (tb){ sec.appendChild(tb); has = true; }
        else if (String(c.data_tables_raw || '').trim()){
          var raw = document.createElement('div'); raw.className = 'dayvee-product__detail-richtext rte'; raw.style.whiteSpace = 'pre-wrap'; raw.textContent = c.data_tables_raw;
          sec.appendChild(heading('Nährstoffangaben')); sec.appendChild(raw); has = true;
        }
      }
      if (!has && meaningful(c.legacy_html || '')){ sec.appendChild(rich(c.legacy_html, 'dayvee-product__legacy-content rte')); has = true; }
      var ut = c.usage_text && String(c.usage_text).trim();
      if (ut || meaningful(c.usage_html || '')){
        var ub = document.createElement('div'); ub.className = 'dayvee-product__detail-block';
        ub.appendChild(heading('Einnahme'));
        if (!meaningful(c.usage_html || '') && ut){ var uw = document.createElement('div'); uw.className = 'dayvee-product__detail-richtext rte'; var up = document.createElement('p'); up.textContent = ut; uw.appendChild(up); ub.appendChild(uw); }
        else ub.appendChild(rich(c.usage_html, 'dayvee-product__detail-richtext rte'));
        sec.appendChild(ub); has = true;
      }
      if (!has) return;
      box.appendChild(sec); n++;
    });
    if (!n) return false;
    ingr.appendChild(box);
    return true;
  }
  function renderIngredients(v){
    if (!ingr || !content) return;
    ingr.innerHTML = '';
    var kids = v && Array.isArray(v.bundle_child_contents) ? v.bundle_child_contents : [];
    if (kids.length > 1 && renderChildContents(kids)) return;
    if (kids.length && isInfinite(kids)){
      var p = document.createElement('p'); p.textContent = 'Die Angaben zu den Komponenten erscheinen mit deiner Bundle-Auswahl.'; ingr.appendChild(p); return;
    }
    var html = '', raw = '', hasI = false, hasT = false;
    if (v && v.has_ingredients_data){ hasI = true; html = v.ingredients_html || ''; }
    else if (content.product_has_ingredients){ hasI = true; html = content.product_ingredients_html || ''; }
    if (v && v.has_data_tables){ hasT = true; raw = v.data_tables_raw || ''; }
    else if (content.product_has_tables){ hasT = true; raw = content.product_tables_raw || ''; }
    var legacy = false;
    if (!hasI && !hasT){
      legacy = true;
      if (meaningful(content.legacy_html || '')) ingr.appendChild(rich(content.legacy_html, 'dayvee-product__legacy-content rte'));
    } else {
      if (hasI && meaningful(html)){
        var ib = document.createElement('div'); ib.className = 'dayvee-product__detail-block';
        ib.appendChild(heading('Zutaten'));
        ib.appendChild(rich(html, 'dayvee-product__detail-richtext dayvee-product__ingredients-richtext rte'));
        ingr.appendChild(ib);
      }
      if (hasT){ var tb = tablesBlock(raw) || plainBlock(raw); if (tb) ingr.appendChild(tb); }
    }
    if (!legacy && meaningful(content.usage_html || '')){
      var ub = document.createElement('div'); ub.className = 'dayvee-product__detail-block';
      ub.appendChild(heading('Verzehrempfehlung'));
      ub.appendChild(rich(content.usage_html, 'dayvee-product__detail-richtext rte'));
      ingr.appendChild(ub);
    }
    /* Ueberschriften aus den Texten ohne Emoji, "Verzehr / Zubereitung" heisst Verzehrempfehlung */
    ingr.querySelectorAll('h2, h3, h4').forEach(function(h){
      var plain = h.textContent.trim().replace(/^[\u{1F9EA}\u{1F4CB}]\s*/u, '');
      if (/Verzehr\s*\/\s*Zubereitung/i.test(plain)) h.textContent = 'Verzehrempfehlung';
      else if (h.textContent !== plain) h.textContent = plain;
    });
  }

  /* ---------- Bundles: Beschreibung und Hersteller der enthaltenen Produkte ---------- */
  function childList(children, title, build){
    var wrap = document.createDocumentFragment();
    var h = document.createElement('h3'); h.className = 'dayvee-product__bundle-section-title'; h.textContent = title; wrap.appendChild(h);
    var box = document.createElement('div'); box.className = 'dayvee-product__bundle-child-details';
    children.forEach(function(c){
      var sec = document.createElement('section'); sec.className = 'dayvee-product__bundle-child';
      var t = document.createElement('h3'); t.className = 'dayvee-product__bundle-child-title'; t.textContent = childTitle(c); sec.appendChild(t);
      build(c, sec); box.appendChild(sec);
    });
    wrap.appendChild(box);
    return wrap;
  }
  function renderBundleDescriptions(children){
    if (!bDesc) return;
    bDesc.innerHTML = '';
    var list = selectedChildren(children).filter(function(c){ return c && meaningful(c.description_html || ''); });
    if (!list.length) return;
    bDesc.appendChild(childList(list, 'Details der enthaltenen Produkte', function(c, sec){
      var html = compactDesc(c.description_html || '');
      if (c.bundle_type === 'Infinite options'){ var s = document.createElement('div'); s.innerHTML = c.description_html || ''; var fp = s.querySelector('p'); html = fp ? fp.outerHTML : html; }
      if (meaningful(html)) sec.appendChild(rich(html, 'dayvee-product__detail-richtext rte'));
      if (c.product_url){ var a = document.createElement('a'); a.className = 'dayvee-product__bundle-child-link'; a.href = c.product_url; a.textContent = 'Zum Einzelprodukt'; sec.appendChild(a); }
    }));
  }
  function renderBundleMakers(children){
    if (!bMaker) return;
    bMaker.innerHTML = '';
    var list = selectedChildren(children).filter(Boolean);
    if (!list.length) return;
    bMaker.appendChild(childList(list, 'Hersteller der enthaltenen Produkte', function(c, sec){
      sec.appendChild(rich(c.manufacturer_html || '', 'dayvee-product__detail-richtext rte'));
    }));
  }
  /* Doppelte Beschriftung "Hersteller" am Anfang der Herstellertexte entfernen (vorher dayvee-site-consistency) */
  function tidyMakers(){
    var panel = dt.querySelector('[data-dayvee-detail-panel="hersteller"]');
    if (!panel) return;
    var boxes = panel.querySelectorAll('.metafield-rich_text_field');
    var targets = boxes.length ? Array.prototype.slice.call(boxes) : [panel];
    targets.forEach(function(tg){
      var first = tg.firstElementChild;
      while (first){
        var label = (first.textContent || '').replace(/\s+/g, ' ').trim().replace(/:$/, '').toLowerCase();
        if (!(label === 'hersteller' || label === 'hersteller / verantwortlicher lebensmittelunternehmer' || label === 'verantwortlicher lebensmittelunternehmer')) break;
        var next = first.nextElementSibling; first.remove(); first = next;
      }
    });
  }

  /* ---------- Wichtige Hinweise (Nahrungsergaenzungsmittel) ---------- */
  var standard = /Die\s+(?:angegebene\s+)?empfohlene\s+tägliche\s+Verzehrs?menge\s+(?:darf\s+nicht\s+überschritten\s+werden|nicht\s+überschreiten)\.|Nahrungsergänzungsmittel\s+(?:sind\s+kein\s+Ersatz\s+für\s+eine|sollten\s+nicht\s+als\s+Ersatz\s+für\s+eine)\s+(?:ausgewogene(?:,|\s+und)\s+abwechslungsreiche|abwechslungsreiche\s+und\s+ausgewogene)\s+Ernährung(?:\s+(?:sowie|und)\s+eine\s+gesunde\s+Lebensweise)?(?:\s+verwendet\s+werden)?\.|Außerhalb\s+der\s+Reichweite\s+von\s+kleinen\s+Kindern\s+(?:aufbewahren|lagern)\./g;
  function dedupe(){
    dt.querySelectorAll('[data-dayvee-detail-panel]:not([data-dayvee-detail-panel="faq"]) p, [data-dayvee-detail-panel]:not([data-dayvee-detail-panel="faq"]) li').forEach(function(p){
      if (p.closest('[data-dayvee-nem-notices]')) return;
      var walker = document.createTreeWalker(p, NodeFilter.SHOW_TEXT), nodes = [], text = '', node;
      while ((node = walker.nextNode())){ nodes.push({ node: node, start: text.length, text: node.textContent }); text += node.textContent; }
      var matches = []; var m; standard.lastIndex = 0;
      while ((m = standard.exec(text))) matches.push({ index: m.index, len: m[0].length });
      if (!matches.length) return;
      nodes.forEach(function(part){
        var c = part.text;
        matches.slice().reverse().forEach(function(mt){
          var s = Math.max(0, mt.index - part.start), e = Math.min(part.text.length, mt.index + mt.len - part.start);
          if (e > s) c = c.slice(0, s) + c.slice(e);
        });
        if (c !== part.text) part.node.textContent = c;
      });
      if (!p.textContent.trim() && !p.querySelector('img, svg, video, iframe, input')) p.remove();
    });
    dt.querySelectorAll('h2, h3, h4').forEach(function(h){
      if (h.closest('[data-dayvee-nem-notices]')) return;
      if (!/^(?:Wichtige Hinweise|Hinweise|Hinweis für Nahrungsergänzungsmittel)$/.test(h.textContent.trim())) return;
      var next = h.nextSibling;
      while (next && !next.textContent.trim()) next = next.nextSibling;
      if (!next || (h.textContent.trim() !== 'Hinweise' && next.nodeType === 1 && /^H[1-6]$/.test(next.tagName))) h.remove();
    });
  }
  function syncNem(children){
    if (!nem || !descPanel) return;
    var sel = selectedChildren(children);
    var pool = sel.length ? sel : children;
    var relevant = isSupp || pool.some(function(c){ return c && c.is_supplement; });
    nem.hidden = !relevant;
    if (!relevant) return;
    dedupe();
    var hint = Array.prototype.slice.call(descPanel.querySelectorAll('h2, h3, h4')).find(function(h){
      return h.textContent.trim() === 'Hinweise' && !h.closest('[data-dayvee-bundle-description]');
    });
    if (hint){ if (hint.nextElementSibling !== nem) hint.after(nem); }
    else if (bDesc){ if (bDesc.previousElementSibling !== nem) bDesc.before(nem); }
    else if (descPanel.lastElementChild !== nem) descPanel.appendChild(nem);
  }

  /* ---------- Bundles: Vegan/Vegetarisch-Badge nach der aktuellen Auswahl ---------- */
  var DIET_HTML = {
    vegan: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 19c0-8 5-13 14-14-1 9-6 14-14 14z"/><path d="M5 19l7-7"/></svg>Vegan',
    vegetarisch: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M8.5 12.5l2.5 2.5 4.5-5"/></svg>Vegetarisch'
  };
  function syncBundleDiet(children){
    if (!root || !root.hasAttribute('data-dpv2-bundle')) return;
    var row = root.querySelector('.dpv2-3info .dpv2-vendor-row');
    if (!row) return;
    var food = selectedChildren(children).filter(function(c){ return c && !c.diet_neutral; });
    if (!food.length) return;
    var d = '';
    if (food.every(function(c){ return c.diet === 'vegan'; })) d = 'vegan';
    else if (food.every(function(c){ return c.diet === 'vegan' || c.diet === 'vegetarisch'; })) d = 'vegetarisch';
    var badge = row.querySelector('.dpv2-diet');
    if (!d){ if (badge) badge.hidden = true; return; }
    if (!badge){ badge = document.createElement('span'); row.appendChild(badge); }
    badge.className = 'dpv2-diet ' + (d === 'vegan' ? 'dpv2-diet--vegan' : 'dpv2-diet--veggie');
    badge.innerHTML = DIET_HTML[d];
    badge.hidden = false;
  }

  /* ---------- Zusammenspiel ---------- */
  var last = '';
  function renderAll(force){
    var v = currentVariant();
    var kids = v && Array.isArray(v.bundle_child_contents) ? v.bundle_child_contents : [];
    var sel = selectedChildren(kids).map(function(c){ return c.variant_id; }).join(',');
    var key = (v ? v.id : '') + '|' + sel;
    if (!force && key === last) return;
    last = key;
    renderIngredients(v);
    renderBundleDescriptions(kids);
    renderBundleMakers(kids);
    tidyMakers();
    syncNem(kids);
    syncBundleDiet(kids);
  }
  renderAll(true);

  if (root){
    var t;
    var soon = function(){ clearTimeout(t); t = setTimeout(function(){ renderAll(false); }, 60); };
    root.addEventListener('dpv2:rendered', soon);
    root.addEventListener('change', soon);
    root.addEventListener('click', function(e){ if (e.target.closest && e.target.closest('[data-dpv2-bslots]')) soon(); });
    /* Die Bundle-App baut ihre Auswahlfelder nachtraeglich in die Kaufkachel */
    var form = root.querySelector('[data-dpv2-form]');
    if (form && dt.querySelector('[data-dayvee-bundle-description], [data-dayvee-bundle-manufacturers]')){
      new MutationObserver(soon).observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['selected', 'value'] });
    }
  }
  window.addEventListener('load', function(){ renderAll(false); });
})();
